export enum NoteType {
  ADMISSIONS = 'Admissions',
  CARE_COORDINATION = 'Care coordination',
  CARE_NAVIGATION = 'Care navigation',
  INTAKE_SESSION = 'Intake session',
  TREATMENT_SESSION = 'Treatment session',
  INTERNAL_CARE_COORDINATION = 'Internal care coordination',
  DISCHARGE_SESSION = 'Discharge session',
  MISSED_SESSION = 'Missed session',
}
